import * as Yup from 'yup';

const setupSignatureSchema = Yup.object({
  pin: Yup.string()
    .matches(/^\d{4,8}$/, 'PIN must be 4-8 digits')
    .required('PIN is required'),
});

export default setupSignatureSchema;
